import { GlobalStyles, CssBaseline as MuiBaseLine, css } from '@mui/material'

import { useAppSelector } from '~/app/hooks'

const FixPreludeToastLayer = () => (
  <GlobalStyles
    styles={(theme) => css`
      .prelude-toast-wrapper {
        z-index: ${theme.zIndex.tooltip};
      }
    `}
  />
)

const SafeAreaPadding = () => {
  const navHide = useAppSelector((state) => state.Ui.navHide)
  const safeAreaInset = useAppSelector((state) => state.Ui.safeAreaInset)

  if (!navHide || !safeAreaInset) {
    return null
  }

  return (
    <GlobalStyles
      styles={css`
        body {
          padding-top: 0;
          padding-top: ${safeAreaInset.top}px;
          padding-bottom: 0;
          padding-bottom: ${safeAreaInset.bottom}px;
        }
      `}
    />
  )
}

const BaseLine = () => (
  <>
    <MuiBaseLine />
    <FixPreludeToastLayer />
    <SafeAreaPadding />
  </>
)

export default BaseLine
